import { Clickable, ClickableProps } from "../shared/clickable/clickable.tsx";
import { Title } from "../shared/title/title.tsx";

import './social.css';

function Social() {
    const logos: ClickableProps[] = [
        
        {
            img: process.env.PUBLIC_URL + '/assets/spotify-logo.png',
            url: 'https://open.spotify.com/artist/393hXDE11Rqi6q49x8KwXO?si=pj3b_ZZHTIOGAFWSsc2vUQ',
            description: 'Spotify',
        },
        {
            img: process.env.PUBLIC_URL + '/assets/instagram-logo.png',
            url: 'https://www.instagram.com/holdmetightband',
            description: 'Instagram'
        },
        {
            img: process.env.PUBLIC_URL + '/assets/bandcamp-logo.png',
            url: 'https://holdmetightband.bandcamp.com/',
            description: 'Bandcamp'
        }
        // {
        //     img: process.env.PUBLIC_URL + '/assets/facebook-logo.png',
        //     url: 'https://www.facebook.com/holdmetightband',
        //     description: 'Facebook',
        // },
        // {
        //     img: process.env.PUBLIC_URL + '/assets/instagram-logo.png',
        //     url: 'https://www.instagram.com/hmt_hc/',
        //     description: 'Instagram'
        // },{
          //  img: process.env.PUBLIC_URL + '/assets/linktree-vector-logo-seeklogo/linktree-seeklogo.png',
           // url: 'https://linktr.ee/hold_me_tight_?utm_source=linktree_profile_share&ltsid=c4596ee5-432b-4a5a-945a-df5612d6295b',
            //description: 'Linktree',
        //},
        // {
        //     img: process.env.PUBLIC_URL + '/assets/bandcamp-logo.png',
        //     url: 'https://holdmetightband.bandcamp.com/',
        //     description: 'Bandcamp'
        // }
        ];

    return <div id='social' className="animated">
        <Title value="Social" />
        <div id='social-container'>
            {logos.map((logo: ClickableProps) => <Clickable {...logo}/>)}
        </div>
    </div>
}

export { Social }